export const ALL_ATTRIBUTES_LABEL = 'All Attributes';
export const VL_ACTIONS = {
    DELETE: 3
};
export const TREE_DEFAULT_DELETE_PERMISSION = 'DeleteTaxonomyEntity';
export const INCOMPATIBLE_VALUE_IN_FORM_ERROR_KEY = 'isIncompatibleValue';

export enum treeOrderDirection {
    asc = 1,
    desc = 2
}

export enum treeOrderType {
    custom = 1,
    default = 2
}
